// extracted by mini-css-extract-plugin
module.exports = {"spinner":"Spinner_spinner__247Re","sk-bouncedelay":"Spinner_sk-bouncedelay__1dc6r","bounce1":"Spinner_bounce1__32-Vr","bounce2":"Spinner_bounce2__3iS95"};